import { Box, IconButton } from "@mui/material";
import { rem } from "assets/js/common";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { loadAction } from "redux/reducers/top";

export default function Terms() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { tp } = useParams();

  useEffect(() => {
    dispatch(
      loadAction({
        back: false,
        title: tp == 1 ? "개인정보 수집 이용동의" : "이용약관",
        menu: false,
      })
    );
  }, []);

  return (
    <>
      <IconButton
        aria-label="close"
        className="btn-close"
        onClick={() => {
          history.push("/");
        }}
        style={{
          position: "fixed",
          top: rem(12),
          right: rem(15),
          width: rem(24),
          height: rem(24),
          backgroundImage: `url(${
            process.env.PUBLIC_URL
          }/images/icon/close.svg)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          zIndex: 99,
        }}
      >
        <span className="hidden">닫기</span>
      </IconButton>
      {tp == 1 ? (
        <Box p={6} sx={{ fontSize: "14px" }}>
          <p>
            (주)메가마트(이하 “회사”라 한다)는 회원의 개인정보를 중요시하며
            정보통신망법, 개인정보보호법 등 “회사”가 준수하여야 할 법령상의
            개인정보보호 규정을 준수하고 있습니다. “회사”는 개인정보취급방침을
            통하여 메가훼미리 포인트카드 회원(이하 “회원”이라 한다)이 제공하는
            개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를
            위해 어떠한 조치가 취해지고 있는지 알려드립니다.
          </p>
          <p>
            <strong>제1조 (수집하는 개인정보의 항목)</strong>
          </p>
          <p>① 회원가입 시</p>
          <ul>
            <li>(1) 필수항목: 이름, 생년월일, 성별, 휴대전화번호</li>
            <li>(2) 선택항목: e-mail, 주소, 차량번호, 마케팅수신 동의여부</li>
          </ul>
          <p>② 고객의 소리(민원) 이용 시</p>
          <ul>
            <li>(1) 필수항목: 이름, 전화번호, e-mail</li>
          </ul>
          <p>
            ③ 서비스 이용 또는 업무처리과정에서 자동으로 생성, 수집될 수 있는
            정보
          </p>
          <ul>
            <li>(1) 인터넷서비스 이용시</li>
            <li>
              - IP Address, 쿠키, 접속로그, 서비스 이용기록, 불량이용 기록 등
            </li>
            <li>(2) 모바일서비스 이용시</li>
            <li>
              - 단말기식별번호, 단말기OS 정보, 이동통신회사, PUSH 수신여부 등
            </li>
            <li>(3) 유료서비스 이용시(결제 및 배송)</li>
            <li>
              - 카드정보, 계좌정보, 포인트카드번호, 주문인 및 수령인의
              성명/주소/연락처/상품/구매내역 등
            </li>
          </ul>
          <p>
            개인정보는 홈페이지, 서면양식, 상담게시판, 전화 등을 통하여
            수집됩니다. 부정확한 정보 제공으로 인해 발생하는 사고의 책임은
            “회원”에게 있으며, 타인의 정보도용 등 허위정보를 입력할 경우 “회원”
            자격이 상실되거나 “회사”는 해당 “회원”을 신고할 수 있습니다.
          </p>
          <p>
            <strong>제2조 (개인정보 수집 및 이용목적)</strong>
          </p>
          <p>“회사”는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
          <p>① 홈페이지 회원가입 및 관리</p>
          <ul>
            <li>
              - 가입의사 확인, 서비스 제공에 따른 본인 식별/인증, "회원" 자격
              유지/관리, 각종 고지 등
            </li>
          </ul>
          <p>② 민원사무 처리</p>
          <ul>
            <li>
              - 신원 확인, 민원사항 확인, 사실조사를 위한 연락/통지, 처리결과
              통보 등
            </li>
          </ul>
          <p>③ 재화 또는 서비스 제공</p>
          <ul>
            <li>
              - 물품배송, 서비스 제공, 청구서 발송, 콘텐츠 제공,맞춤 서비스
              제공, 결제/정산, 채권추심 등
            </li>
          </ul>
          <p>④ 마케팅 및 광고에의 활용</p>
          <ul>
            <li>
              - 신규 서비스 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공
              등
            </li>
          </ul>
          <p>⑤ 메가포인트 훼미리카드 서비스 제공</p>
          <ul>
            <li>
              - 메가포인트 훼미리카드 서비스 제공을 위한 카드발급, 포인트
              적립/사용, 정산 등
            </li>
          </ul>
          <p>
            <strong>제3조 (개인정보의 보유 및 이용기간)</strong>
          </p>
          <p>
            ① “회사”는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당
            정보를 지체없이 파기합니다. 단, 법령에 따라 특별한 규정이 있는
            경우에는 관련 법령에 따라 보유 및 이용합니다.
          </p>
          <ul>
            <li>- 관계법령에 의한 보유</li>
            <li>(가) 계약 또는 청약철회 등에 관한 기록 : 5년</li>
            <li>(나) 대금결제 및 재화 등의 공급에 관한 기록 : 5년</li>
            <li>(다) 소비자의 불만또는 분쟁처리에 관한 기록 : 3년</li>
            <li>(라) 인터넷 로그 기록 : 3개월</li>
          </ul>
          <p>
            ② 1년 동안 서비스를 이용하지 않은 “회원”의 개인정보는 접근이 불가한
            별도의 테이블에 보관되어 휴면회원으로 전환되며, 이후 4년 동안 서비스
            미이용시 개인정보는 파기됩니다. “회사”는 개인정보 분리/보관 또는
            파기 시점이 도래하기 1개월 이전에 이메일 등을 통해 해당 “회원”에게
            관련내용을 고지합니다
          </p>
          <p>
            <strong>제4조 (개인정보 제3자 제공)</strong>
          </p>
          <p>
            ① “회사”는 “회원”의 개인정보를 사전 동의 없이 제3자에게 제공하지
            않습니다.
          </p>
          <p>
            ② “회사”는 “회원”의 개인정보를 제3자에게 제공하기 이전에 다음의 모든
            사항을 “회원”에게 알리고 동의를 받습니다.
          </p>
          <ul>
            <li>(1) 개인정보를 제공받는 자</li>
            <li>(2) 개인정보를 제공받는 자의 개인정보 이용 목적</li>
            <li>(3) 제공하는 개인정보의 항목</li>
            <li>(4) 개인정보를 제공받는 자의 개인정보 보유 및 이용기간</li>
          </ul>
          <p>
            ③ 다음의 경우에는 관련 법령의 규정에 의하여 “회원”의 동의 없이
            개인정보를 제공할 수 있습니다.
          </p>
          <ul>
            <li>
              (1) 통계, 연구 등을 위해 본인을 알아볼 수 없는 형태로 가공하여
              제공하는 경우
            </li>
            <li>(2) 법령의 규정에 의하거나 수사기관의 요구가 있는 경우</li>
          </ul>
          <table>
            <thead>
              <tr>
                <td>
                  <p>
                    <strong>제공받는 자</strong>
                  </p>
                </td>
                <td>
                  <p>
                    <strong>이용 목적</strong>
                  </p>
                </td>
                <td>
                  <p>
                    <strong>제공하는 개인정보항목</strong>
                  </p>
                </td>
                <td>
                  <p>
                    <strong>보유 및 이용기간</strong>
                  </p>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>관할 세무서</p>
                </td>
                <td>
                  <p>주류 통신판매 주문에 대한 분기별 명세 세무서 제공</p>
                </td>
                <td>
                  <p>
                    주문자 인적사항(주소, 성명, 생년월일), 주문일자, 상품명,
                    수량, 주문금액
                  </p>
                </td>
                <td>
                  <p>국세청 고시에 다른 보존기간</p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong>제5조 (수집한 개인정보의 위탁)</strong>
          </p>
          <p>
            “회사”는 서비스 이행을 위해 아래와 같이 외부 전문업체에 위탁하여
            운영하고 있습니다.
          </p>
          <p>① ㈜엔디에스</p>
          <ul>
            <li>- "회원" 정보 DB 시스템 운영/관리시 업무(전산 아웃소싱)</li>
          </ul>
          <p>② ㈜NICE 신용평가</p>
          <ul>
            <li>- 본인확인 서비스 업무</li>
          </ul>
          <p>③ CJ 대한통운, 현대 글로비스, 한진 종합물류기업, ㈜한솔로지스</p>
          <ul>
            <li>- 상품 배송 업무</li>
          </ul>
          <p>④ 나이스 페이먼츠</p>
          <ul>
            <li>- 결제정보 전송, 결제대행, 간편/자동결제 대행 업무</li>
          </ul>
          <p>⑤ ㈜LG CNS</p>
          <ul>
            <li>- 신카카오톡 알림톡(상품 주문/배송)</li>
          </ul>
          <p>⑥ (유)코리아 맨파워, ㈜신명써비스</p>
          <ul>
            <li>
              - 주문 상품 피킹, 품절상품 안내, 불만 접수 처리 등 민원처리 업무,
              (고객센터 운영)"회원" 만족도 조사
            </li>
          </ul>
          <p>⑦ ㈜브라이트유니온, ㈜비알피엠씨</p>
          <ul>
            <li>- 신선도원몰 "회원" 관리 업무(제2조 포함)</li>
          </ul>
          <p>⑧ 모노커뮤니케이션즈</p>
          <ul>
            <li>- 문자 발송 업무</li>
          </ul>
          <p>⑨ AWS 코리아</p>
          <ul>
            <li>- AWS를 통한 시스템 관리 업무</li>
          </ul>
          <p>⑩ ㈜채널 코퍼레이션</p>
          <ul>
            <li>- 1:1 채팅 상담</li>
          </ul>
          <p>
            “회사”는 위탁계약 체결 시 수행목적 외 개인정보 처리금지,
            기술적/관리적 보호조치, 수탁자에 대한 관리/감독, 손해배상 등 책임에
            관한 사항을 계약서 등 문서에 명시하며 수탁자가 개인정보를 안전하게
            처리하는 지를 감독하고 있습니다.
          </p>
          <p>
            <strong>제6조 (개인정보의 파기 절차 및 방법)</strong>
          </p>
          <p>① 파기절차</p>
          <p>
            - “회원”이 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의
            경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호
            사유에 따라 일정 기간 저장된 후 파기되어집니다. 별도로
            보관된 개인정보는 법률에 의한 경우가 아니고는 보유되어지는 이외의
            다른 목적으로 이용되지 않습니다
          </p>
          <p>② 파기방법</p>
          <ul>
            <li>
              (1) 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는
              기술적 방법을 사용하여 삭제합니다.
            </li>
            <li>
              (2) 종이(서면)에 작성/출력된 개인정보는 분쇄기로 분쇄하거나 소각
              등의 방법으로 파기합니다.
            </li>
          </ul>
          <p>
            <strong>제7조 (개인정보의 열람, 정정, 탈퇴 및 동의철회)</strong>
          </p>
          <p>
            ① “회원”은 언제든지 등록되어 있는 개인정보를 조회하거나 수정할 수
            있으며 가입해지를 요청할 수도 있습니다.
          </p>
          <ul>
            <li>
              (1) 웹페이지 : 로그인 후 '정보수정'을 클릭하여 개인정보 열람, 정정
              또는 탈퇴 가능
            </li>
            <li>
              (2) 고객센터 방문 : 본인확인 후 개인정보 열람, 정정, 탈퇴 가능
            </li>
            <li>(3) 개인정보보호책임자 연락 시 지체 없이 조치</li>
          </ul>
          <p>
            ② "회원"이 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을
            완료하기 전까지 해당 "회원"의 개인정보를 이용 또는 제공하지
            않습니다.
          </p>
          <p>
            ③ 잘못된 개인정보를 이미 제공한 경우에는 정정 처리결과를 지체없이
            통지하여 정정이 이루어지도록 합니다.
          </p>
          <p>
            <strong>제8조 (개인정보 보안유지)</strong>
          </p>
          <p>① 내부관리계획의 수립 및 시행</p>
          <ul>
            <li>
              - "회사"의 내부관리계획은 내부관리 지침을 준수하여 시행합니다.
            </li>
          </ul>
          <p>② 개인정보에 대한 접근 제한</p>
          <ul>
            <li>
              - 개인정보처리시스템에 대한 접근권한의 부여, 변경, 말소를 통하여
              개인정보에 대한 접근통제에 필요한 조치를 하고 있으며
              침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고
              있습니다.
            </li>
          </ul>
          <p>③ 접속기록의 보관 및 위조·변조 방지</p>
          <ul>
            <li>
              - 개인정보처리시스템에 접속한 기록(웹 로그, 요약정보 등)을 최소
              6개월 이상 보관 및 관리하고 있으며, 접속 기록이 위/변조 및
              도난되지 않도록 보안기능을 사용하고 있습니다.
            </li>
          </ul>
          <p>④ 개인정보의 암호화</p>
          <ul>
            <li>- “회원”의 개인정보는 암호화되어 저장 및 관리되고 있습니다.</li>
          </ul>
          <p>⑤ 해킹 등에 대비한 기술적 대책</p>
          <ul>
            <li>
              - "회사"는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및
              훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신/점검을
              하고 있습니다.
            </li>
          </ul>
          <p>
            <strong>
              제9조 (개인정보 자동수집 장치의 설치운영 및 그 거부에 관한 사항)
            </strong>
          </p>
          <p>
            “회사"는 "회원"의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’
            등을 운용합니다. 쿠키란 “회사”의 웹사이트를 운영하는데 이용되는
            서버가 “회원”의 브라우저에 보내는 아주 작은 텍스트 파일로서 “회원”의
            컴퓨터 하드디스크에 저장됩니다. “회사”는 다음과 같은 목적을 위해
            쿠키를 사용합니다.
          </p>
          <p>① 쿠키 등 사용목적</p>
          <ul>
            <li>
              - 쿠키는 접속빈도나 방문시간 분석, "회원"의 관심분야 파악 및 자취
              추적, 각종 이벤트참여 정도 및 방문 횟수 파악 등을 통한 타겟 마케팅
              및 개인맞춤 서비스 제공 등에 활용됩니다. "회원"은 쿠키 설치에 대한
              선택권을 가지고 있으며 웹브라우저에서 옵션을 설정함으로써 모든
              쿠키를  허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면
              모든 쿠키의 저장을 거부할 수도 있습니다.
            </li>
          </ul>
          <p>② 쿠키 설정 거부 방법</p>
          <ul>
            <li>
              - 쿠키 설정을 거부하는 방법으로는 회원이 사용하는 웹브라우저의
              옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다
              확인을 거치거나 모든 쿠키의 저장을 거부할 수 있습니다.
            </li>
            <li>
              - 인터넷 익스플로어 : 횝 브라우저 상단 도구 &gt; 인터넷 옵션 &gt;
              개인정보 &gt; 고급 &gt; 허용여부 선택
            </li>
            <li>
              - 단, 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수
              있습니다.
            </li>
          </ul>
          <p>
            <strong>제10조 (개인정보에 관한 민원서비스)</strong>
          </p>
          <p>
            ① “회사”는 “회원”의 개인정보를 보호하고 개인정보와 관련한 민원을
            해결하기 위하여 아래와 같이 관련 부서 및 개인정보보호책임자를
            지정하고 있습니다. “회원”은 “회사”의 서비스를 이용하며 발생하는 모든
            개인정보보호 관련 민원을 개인정보보호책임자 혹은 담당부서로 신고할
            수 있습니다. “회사”는 “회원”의 신고사항에 대해 신속하게 충분한
            답변을 드릴 것입니다.
          </p>
          <ul>
            <li>- 개인정보보호부서 : 판매본부 마케팅전략팀</li>
            <li>
              - 개인정보보호책임자 : 정연석 상무(전화번호 : 02-820-8580 / 이메일
              : orange@megamart.com)
            </li>
            <li>
              - 개인정보보호관리자 : 김지현 주임(전화번호 : 02-827-1057 / 이메일
              : 2009499@megamart.com)
            </li>
          </ul>
          <p>
            ② 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래
            기관에 문의하시기 바랍니다.
          </p>
          <ul>
            <li>
              (1) 개인분쟁조정위원회(http://privacy.kisa.or.kr, 02-405-5118)
            </li>
            <li>
              (2) 정보보호마크인증위원회 (http://www.eprivacy.or.kr,
              02-550-9531~2)
            </li>
            <li>
              (3) 대검찰청 인터넷범죄수사센터 (http://www.spo.go.kr,
              02-3480-2000)
            </li>
            <li>
              (4) 경찰청 사이버테러대응센터 (http://www.ctrc.go.kr, 02-393-9112)
            </li>
          </ul>
          <p>
            <strong>제11조 (아동의 개인정보보호)</strong>
          </p>
          <p>
            “회사”는 법정대리인의 동의가 필요한 만 14세 미만 아동의 회원가입을
            받지 않습니다.
          </p>
          <p>
            <strong>제12조 (개인정보 처리방침 변경에 관한 사항)</strong>
          </p>
          <p>
            현 개인정보처리방침 중 관련 법률의 제/개정, 정부의 정책 변경,
            “회사”의 내부방침의 변경 또는 보안기술의 변경에 따라 내용의
            추가/삭제 및 수정이 있을 시에는 개정 최소 7일 전부터 홈페이지의
            공지사항을 통해 고지하겠습니다
          </p>
        </Box>
      ) : (
        <Box p={6} sx={{ fontSize: "14px" }}>
          <strong>
            제1장.총칙
            <br />
            <br />
            <span>
              <span>제1조(목적)</span>
              <br />
            </span>
          </strong>
          <span>
            <span>
              본 약관은 ㈜메가마트(이하 "회사"라 한다)가 제공하는 "메가포인트
              훼미리카드 서비스" 이용과 관련한 제반 사항을 명확히 규정함으로써
              "메가포인트 훼미리카드 회원"에 대한 서비스 증진을 도모함을 그
              목적으로 합니다.
            </span>
          </span>
          <strong>
            <span>
              <br />
              <br />
              <span>제2조(용어의 정의)</span>
              <br />
            </span>
          </strong>
          <span>
            <span>
              ① "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)"이란 본 약관에
              동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
            </span>
            <br />
            <span>
              ② "메가포인트 훼미리카드 서비스(이하 "서비스"라 한다)"란 "회사"가
              제공하는 서비스로서 그 내용은 본 약관 제2장에 기술된 바와
              같습니다.
            </span>
            <br />
            <span>
              ③ "메가포인트 훼미리카드(이하 "카드"라 한다)”란 “회사"가 인정하는
              절차 및 방법에 따라 발급되어 "서비스"를 정상적으로 사용할 수
              있도록 승인된 "카드"를 말합니다.
            </span>
            <br />
            <span>
              ④ "메가포인트 훼미리카드 포인트(이하 "포인트"라 한다)"란 “회원"이
              상품을 구매하거나 서비스를 이용하는 경우 "회사"가 정하는 바에 따라
              부여되는 "포인트"를 의미합니다.
            </span>
          </span>
          <strong>
            <span>
              <br />
              <br />
              <span>제3조(약관의 효력)</span>
              <br />
            </span>
          </strong>
          <span>
            <span>
              ① 본 약관의 내용은 웹페이지에 게시하거나 기타의 방법으로 공지하고,
              본 약관에 동의한 "회원" 모두에게 그 효력이 발생합니다.
            </span>
            <br />
            <span>
              ② 본 약관은 "회원"이 동의한 날로부터 탈퇴 또는 해지 시까지
              적용되는 것을 원칙으로 합니다. 단, 본 약관의 일부 조항은
              이용계약의 해지 후에도 유효하게 적용될 수 있습니다.
            </span>
          </span>
          <strong>
            <span>
              <br />
              <br />
              <span>제4조(약관의 변경)</span>
              <br />
            </span>
          </strong>
          <span>
            <span>
              ① "회사"는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 본
              약관을 변경할 수 있습니다. 본 약관이 개정되는 경우, "회사"는 매장
              게시, 전단 공고, 우편물 통보, 웹페이지 공지 등의 방법 중 한 가지
              이상의 방법으로 "회원”에게 알립니다.
            </span>
            <br />
            <span>
              ② 본 약관이 변경되는 경우 "회사"는 변경사항을 시행일자 15일 전부터
              공지 또는 통지하는 것을 원칙으로 하며, 피치 못하게 불리한 내용으로
              변경할 경우에는 그 시행일자 30일 전부터 공지 또는 통지합니다.
            </span>
            <br />
            <span>
              ③ "회원"은 변경된 약관에 대하여 거부의사를 표시함으로써 이용계약의
              해지를 선택할 수 있습니다. 단, 공지 또는 통지일로부터 개정약관
              시행일 7일 후까지 거부의사를 표시하지 아니하면 변경된 약관을
              승인한 것으로 봅니다.
            </span>
            <br />
            <span>
              ④ 본 약관의 일부 조항은 이용계약의 해지 후에도 유효하게 적용될 수
              있습니다.
            </span>
          </span>
          <strong>
            <span>
              <br />
              <br />
              <span>제5조(약관에서 정하지 아니한 사항)</span>
              <br />
            </span>
          </strong>
          <span>
            <span>
              ① "회사"는 개별서비스 등에 대하여 별도의 이용약관 및 운영정책(이하
              "개별서비스 이용약관 및 정책"이라 한다)을 둘 수 있으며,
              "개별서비스 이용약관 및 정책"의 내용이 본 약관과 상충할 경우에는
              개별서비스 약관 등이 우선하여 적용됩니다.
            </span>
            <br />
            <span>
              ② 본 약관에서 정하지 아니한 사항과 본 약관의 해석에 관하여서는
              관계 법령 및 상관례에 따릅니다.
            </span>
          </span>
          <strong>
            <span>
              <br />
              <br />
              <br />
            </span>
            제2장.제공 서비스
            <br />
            <span>제6조(서비스의 이용)</span>
            <br />
          </strong>
          ① "서비스"는 만 14세 이상의 국내 거주 내/외국인에 한하여 가입이
          가능하며, 대상연령이 아닌 경우 가입되지 않습니다.
          <br />② "서비스"는 자격이 부여된 "회원" 본인이 직접 사용하여야 하며,
          등록된 명의인 이외의 자가 "서비스"를 이용하게 하여서는 안됩니다.
          <br />③ "회원"은 "카드"를 분실하거나 도난당한 경우 “회사"에 즉시
          통보해야 하며, "카드" 분실로 인해 발생되는 모든 책임은 “회원” 본인에게
          있습니다.
          <br />④ “회원”은 "회사"의 고객센터, 점포, 혹은 웹사이트 정보변경
          페이지 등을 통해 등록한 정보를 변경할 수 있습니다.
          <br />
          <strong>
            <br />
            <span>제7조(포인트의 적립)</span>
            <br />
          </strong>
          ① “포인트”는 “회원”이 상품 및 서비스를 구매한 금액에 비례하여 “회사”가
          정하는 적립율에 따라 부여됩니다.
          <br />② “회사”의 정책에 따라 적립율은 별도로 적용될 수 있으며 이 경우
          해당 내용을 별도 표기 또는 안내합니다.
          <br />③ 신용, 체크 타입의 카드를 통해 “포인트” 적립과 이용 대금의
          결제까지 진행하는 경우 "회사"와 제휴카드사 간에 약정된 별도 적립율에
          따라 부여되며, 적립 일시 및 적립 관련 상세 기준은 제휴카드사의 약관에
          따릅니다.
          <br />④ “포인트”는 “회원”의 상품 구매 또는 “서비스” 이용 당시에
          적립하는 것이 원칙이나, 그 당시에 적립하지 못했을 경우에는 상품을
          구매하거나 “서비스”를 이용한 날로부터 30일 내에 적립이 가능합니다. 단,
          적립 시 해당 상품 및 서비스 구매에 관한 유효한 영수증을 함께
          제시하여야 합니다.
          <br />⑤ 점포 내 일부 임대매장에서는 “포인트” 적립이 불가할 수 있으며,
          적립율이 별도로 적용될 수 있습니다.
          <strong>
            <br />
            <br />
            <span>제8조(포인트의 사용)</span>
            <br />
          </strong>
          ① “포인트”를 사용하기 위해서는 "회원"의 지위를 획득하고 "카드"를
          발급받아 소유해야 합니다.
          <br />② "포인트"를 보유한 "회원"은 "회사"가 정한 소정의 절차에 따라
          상품 구매나 “서비스” 이용에 따른 대금의 일부 또는 전부를 "포인트"로
          결제할 수 있습니다. 단, 일부 상품(주류, 담배 및 쇼핑 봉투 등)의
          구매에는 결제할 수 없습니다.
          <br />③ "포인트"는 "포인트"가 10점 이상일 경우 10포인트 단위로 사용
          가능하며, 1포인트는 1원으로 환산합니다.
          <br />④ “포인트” 거래는 “포인트”의 발행 시점부터 시행할 수 있습니다.
          단, "회사"의 일부 “서비스” 경우 "회사"가 정한 별도의 "포인트" 적립
          시점이 적용될 수 있습니다.
          <br />⑤ "포인트"가 “포인트” 취소분보다 부족한 경우, “포인트”는
          마이너스 “포인트”로 관리되며, 추후 적립되는 “포인트”와 상계됩니다.
          <br />⑥ “회원”의 “포인트”가 5,000점 이상이 되었을 때부터 상품권으로
          교환하여 사용하실 수 있습니다.
          <br />⑦ 점포 내 일부 임대매장에서는 “포인트” 사용이 불가할 수
          있습니다.
          <strong>
            <br />
            <br />
            <span>제9조(포인트의 소멸정정양도)</span>
            <br />
          </strong>
          ① “포인트”는 최종 적립일로부터 2년간 유효하며 “포인트”를 적립한 후
          유효기간이 경과된 “포인트”는 유효기간 경과분에 한해 월 단위로 자동
          소멸됩니다.
          <br />② “회원”은 “포인트”를 타인에게 양도하거나 담보로 제공할 수
          없습니다. 단, “회사”가 사전에 서면 동의한 경우에는 허용됩니다.
          <br />③ “포인트” 적립에 오류가 있을 경우 “회원”은 오류 발생 시점부터
          30일 이내에 조정할 수 있습니다. 단, “회원”은 이를 증명할 수 있는
          영수증이나 기타자료를 제시해야 합니다.
          <strong>
            <br />
            <br />
            <br />
            <span>제10조(회원탈퇴 혹은 자격정지)</span>
            <br />
          </strong>
          ① “회사”는 다음 각 호의 경우 “회원”의 자격을 상실 또는 정지시킬 수
          있습니다.
          <br />
          (1) 회원가입 신청 시에 허위 내용을 등록하거나 타인의 명의를 도용한
          경우
          <br />
          (2) “카드”, “포인트”, 기타 "서비스"를 부정한 방법 또는 목적으로 이용한
          경우
          <br />
          (3) 다른 “회원”의 “카드” 이용을 방해하거나 정보를 도용하는 등
          거래질서를 위협하는 경우
          <br />
          (4) 본 약관 및 관계법령이 금지하거나 사회상규에 반하는 행위를 하는
          경우
          <br />② 전항의 사유로 “회원”자격이 상실 또는 정지된 “회원”은 각 호
          사유에 대해 자신의 고의 또는 과실이 없었음을 소명할 수 있으며,
          “회사”는 이를 심사하여 “카드” 이용 여부를 결정할 수 있습니다.
          <br />③ “회사”는 부정한 목적의 반복적인 탈퇴와 재가입을 막기 위하여,
          탈퇴 “회원”의 재가입을 제한할 수 있습니다.
          <br />④ 탈퇴를 하고자 하는 “회원”은 “서비스”의 효력 정지일까지 적립된
          “포인트”를 사용해야 하며, 탈퇴로 인한 효력 정지일까지 사용되지 않은
          “포인트”는 자동 소멸됩니다.
          <br />⑤ 최종 "서비스" 이용일로부터 1년간 이용 내역이 없을 경우 휴면
          전환되어 개인정보를 분리 보관합니다. 분리 보관 이후 4년 동안 이용
          내역이 없을 경우 개인정보를 파기하고 탈퇴 처리합니다.
          <strong>
            <br />
            <br />
            <br />
            <span>제11조(서비스의 종료)</span>
            <br />
          </strong>
          “서비스”를 종료하고자 할 때 “회사”는 중단 시점 30일 이전에 안내물을
          통하여 “회원”에게 통보하며, “서비스”의 종료 기준일은 안내물에 명시된
          일자로 합니다. 이때 적립된 “포인트”를 종료일 이전에 사용하여야 하며
          “서비스”의 종료일까지 사용되지 않은 “포인트”는 소멸됩니다.
          <strong>
            <br />
            <br />
            제3장.기타
            <br />
            <span>제12조(정보제공)</span>
            <br />
          </strong>
          “회사”는 “회원”에게 보다 나은 서비스를 제공하기 위하여 일부 업무를
          전문업체에 위임할 수 있으며, 이 경우에는 “회원”이 동의한 바에 의하여
          “회원”의 성명과 주소, 전화번호 및 전자우편주소를 대행업체에게 알려 줄
          수 있습니다.
          <strong>
            <br />
            <br />
            <span>제13조(분쟁의 조정 및 관할법원)</span>
            <br />
          </strong>
          본 약관에 따른 분쟁의 조정은 일반 상관례에 따라 “회원”과 “회사”가 상호
          협의하여 결정하되, 합의가 안 되어 분쟁 및 소송이 생긴 경우
          민사소송법상의 관할법원은 “회사”의 소재지 관할법원으로 합니다.
          <strong>
            <br />
            <br />
            부칙
            <br />
            이용약관 버전번호: V 1.2
            <br />본 약관은 2022년 1월 1일부터 시행하며 종전의 약관은 이
            약관으로 대체합니다.
            <br />
            <br />
          </strong>
        </Box>
      )}
    </>
  );
}
